import React, { useEffect, useState } from 'react';

const GOOGLE_TRANSLATE_SCRIPT_ID = 'google-translate-script';
const GOOGLE_TRANSLATE_CONTAINER_ID = 'google_translate_element';
const INCLUDED_LANGUAGES = 'af,sq,ar,hy,az,eu,be,bn,bs,ca,hr,cs,da,nl,en,eo,et,tl,fi,fr,ga,de,el,gu,ht,ha,he,hi,hu,is,id,it,jv,ja,kn,km,ko,ku,la,lv,lt,lb,mk,ml,mn,mi,mr,my,ne,no,pl,pt,pa,ro,ru,sr,si,sk,sl,es,su,sw,sv,ta,te,th,tr,uk,ur,vi,cy,xh,yi,zu';

const LanguageSwitcher = () => {

  useEffect(() => {
    let isMounted = true;

    const initializeGoogleTranslate = () => {
      if (!isMounted || !window.google?.translate?.TranslateElement) return;

      const container = document.getElementById(GOOGLE_TRANSLATE_CONTAINER_ID);
      if (!container || container.dataset.googleTranslateInitialized === 'true') return;

      try {
        container.dataset.googleTranslateInitialized = 'true';
        new window.google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: INCLUDED_LANGUAGES,
          layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL,
          autoDisplay: false,
        }, GOOGLE_TRANSLATE_CONTAINER_ID);
      } catch (initError) {
        delete container.dataset.googleTranslateInitialized;
        console.error('Error initializing Google Translate:', initError);
      }
    };

    const handleScriptError = (event) => {
      console.error('Error loading Google Translate script:', event);
    };

    window.googleTranslateElementInit = initializeGoogleTranslate;

    let script = document.getElementById(GOOGLE_TRANSLATE_SCRIPT_ID)
      || document.querySelector('script[src*="translate.google.com/translate_a/element.js"]');

    if (!script) {
      script = document.createElement('script');
      script.id = GOOGLE_TRANSLATE_SCRIPT_ID;
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    script.addEventListener('load', initializeGoogleTranslate);
    script.addEventListener('error', handleScriptError);
    initializeGoogleTranslate();

    return () => {
      isMounted = false;
      script.removeEventListener('load', initializeGoogleTranslate);
      script.removeEventListener('error', handleScriptError);
    };
  }, []);

  return (
    <div className="language-switcher">
      <div id={GOOGLE_TRANSLATE_CONTAINER_ID}></div>
    </div>
  );
};

export default LanguageSwitcher;
